import { render, staticRenderFns } from "./BuddhismList.vue?vue&type=template&id=7276d9c2&scoped=true"
import script from "./BuddhismList.vue?vue&type=script&lang=js"
export * from "./BuddhismList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7276d9c2",
  null
  
)

export default component.exports